<template>
	<sf-modal-layout size="l" :title="OpCdPopupInfo.title" :show="display" :closeModal="popupClose">
		<div class="sf-flex-column">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<op-cd-popup-search ref="search" :scrId="scrId"></op-cd-popup-search>
				</sf-card>
			</div>

			<div class="sf-col sf-col-15">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<op-cd-popup-table ref="table" @Refresh="Refresh" :scrId="scrId" @selectOpCd="selectOpCd"></op-cd-popup-table>
				</sf-card>
			</div>
		</div>
	</sf-modal-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/ceqi/CmpnMst/store/helpers';

import OpCdPopupSearch from './Search/OpCdPopupSearch.vue';
import OpCdPopupTable from './Table/OpCdPopupTable.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			initState: false,
			display: false,
			OpCdPopupInfo: {
				title: ''
			}
		};
	},
	components: { OpCdPopupSearch, OpCdPopupTable },
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		async open(param) {
			this.setOpCdPopupSearchInit_();
			this.display = true;
			this.OpCdPopupInfo.title = param.title;
			let searchOpCd = '';
			let searchPartNo = '';

			try {
				if (param) {
					this.$sf_toggleLoading(true);
					this.isLoading = true;
					searchOpCd = param.opCd;
					searchPartNo = param.causPartNo.slice(0, 5);
					await this.setOpCdPopupSearchParams_({ key: 'opCd', value: searchOpCd });
					await this.setOpCdPopupSearchParams_({ key: 'partNo', value: searchPartNo });
					await this.$refs.search.searchList();
				}
			} catch (error) {
			} finally {
				this.isLoading = false;
				this.$sf_toggleLoading(false);
			}
		},
		Refresh() {
			//$refs 는 컴포넌트에 ref로 정의한 이름으로 접근할때 사용한다.
			this.$refs.search.searchList();
		},
		popupClose() {
			this.display = false;
		},
		selectOpCd(row) {
			this.$emit('SendData', row);
			this.popupClose();
		}
	}
};
</script>
